<template>
 
  <div class="product-add pb50">
   <!--编辑素材-->
    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">编辑素材</div>
      <el-form-item label="素材内容" prop="material_title">
        <el-input type="textarea" rows="5" v-model="form.material_title" autocomplete="off" placeholder="请输入素材内容" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="素材类型：" :rules="[{ required: true, message: '素材类型' }]" prop="material_type">
        <el-radio-group v-model="form.material_type">
          <el-radio :label="10">图片</el-radio>
          <el-radio :label="20">视频</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="素材图片：" :rules="[{ required: true, message: '请上传素材图片' }]" prop="image" v-if="form.material_type == 10">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.image">
            <transition-group>
              <div class="item" v-for="item in form.image" :key="item.file_path">
                <img v-img-url="item.file_path" />
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(item)"><i class="el-icon-close"></i></a>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openProductUpload"><i class="el-icon-plus"></i></div>
        </div>
      </el-form-item>
      <el-form-item label="素材视频" v-if="form.material_type == 20">
        <div>
          <el-button type="primary" @click="openVideoUpload">上传视频</el-button>
          <video :src="videopath" class="mt10" width="120px;" height="120px" v-if="isVideo" :isVideo="isVideo" controls="controls" />
          <!--上传图片组件-->
          <Video v-if="isvideoupload" :config="{ total: 1 }" :isvideoupload="isvideoupload" @returnImgs="returnVideoFunc">上传视频</Video>
        </div>
      </el-form-item>
      <el-form-item label="素材分类">
        <el-select v-model="form.category_id" placeholder="请选择">
          <el-option v-for="(item, index) in category" :key="index" :label="item.name" :value="item.category_id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="关联产品">
        <div>
          <el-button type="primary" @click="openProduct">选择商品</el-button>
          <template v-if="form.product_id">
            <el-button  @click="deleteFunc()" type="text" size="small">删除</el-button>
            <img :src="product.image" class="mt10" width="120px;" />
            <div>商品名称：{{product.product_name}}</div>
          </template>
        </div>
         <div class="gray">绑定产品，其他消费者通过该素材直接下单，素材发布者可以获得一定的收益</div>
      </el-form-item>

      <el-form-item label="虚拟阅读量"><el-input type="number" v-model="form.virtual_views" placeholder="请输入数字" class="max-w460"></el-input></el-form-item>
      <el-form-item label="素材状态">
        <el-radio-group v-model="form.material_status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="排序">
        <el-input type="number" v-model="form.material_sort" placeholder="请输入数字" class="max-w460"></el-input>
        <div class="gray">数字越小越靠前</div>
      </el-form-item>
      <div v-if="form.user_id">
          <el-form-item label="发布人">
            <div>
              <img :src="form.user.avatarUrl" class="mt10" width="120px;" style="display: block;" />
            </div>
            <div>ID:{{form.user.user_id}}【{{form.user.nickName}}】</div>
        </el-form-item>
      </div>
      <div v-else>
          <el-form-item label="发布人头像">
          <div>
            <el-button type="primary" @click="openUpload">上传图片</el-button>
            <img :src="path" class="mt10" width="120px;" v-if="isImg" :isImg="isImg" style="display: block;" />
            <!--上传图片组件-->
            <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
          </div>
        </el-form-item>
        <el-form-item label="发布人昵称" prop="nickName"><el-input v-model="form.nickName" placeholder="请输入发布人昵称" class="max-w460"></el-input></el-form-item>
      </div>
      
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
    <!--产品列表弹出层组件-->
    <Product :isproduct="isproduct" @closeDialog="closeDialogFunc($event)">产品列表弹出层</Product>
  </div>
</template>

<script>
import MaterialApi from '@/api/material.js';
import Product from '@/components/product/Product';
import Upload from '@/components/file/Upload';
import Video from '@/components/file/Video';
import draggable from 'vuedraggable';
export default {
  components: {
    Video: Video,
    Product:Product,
    /*图片上传*/
    Upload: Upload,
    draggable,
  },
  data() {
    return {
      /*是否打开产品弹出层*/
      isproduct: false,
      /*是否上传图片*/
      isupload: false,
      isvideoupload:false,
      isImg: false,
      isVideo: false,
      isProductUpload: false,
      path: '',
      videopath: '',
      /*form表单数据*/
      form: {
        nickName:'',
        material_title: '',
        category_id: '',
        image_id: '',
        product_id: '',
        video_id:'',
        avatar:"",
        material_sort: 1,
        material_status: 1,
        virtual_views: 1,
        image: [],
        dec: '',
        material_type:10,
      },
      product:{},
      /*素材类别*/
      catgory: [],
      loading: false,
      /*验证规则*/
      rules: {
        material_title: [{ required: true, message: '请输入素材内容', trigger: 'blur' }],
        nickName: [{ required: true, message: '请输入发布人昵称', trigger: 'blur' }],
      }
    };
  },

  created() {
    this.path = this.form.avatar?from.avatar.file_path:'';
    /*获取列表*/
    this.getCategoryList();
  },
  methods: {
    /*打开上传图片*/
    openProductUpload: function() {
      this.isProductUpload = true;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgs = this.form.image.concat(e);
        this.$set(this.form, 'image', imgs);
      }
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(e) {
      for (var i = 0; i < this.form.image.length; i++) {
        if (e.file_id == this.form.image[i].file_id) {
          this.form.image.splice(i, 1);
        }
      }
    },
    /*上传*/
    openUpload() {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.avatar = e[0].file_id;
        this.path = e[0].file_path;
        this.isImg = true;
      }
      this.isupload = false;
    },
    /*上传视频*/
    openVideoUpload() {
      this.isvideoupload = true;
    },

    /*获取视频*/
    returnVideoFunc(e) {
      let self = this;
      if (e != null) {
        this.form.video_id = e[0].file_id;
        this.videopath = e[0].file_path;
        this.isVideo = true;
      }
      this.isvideoupload = false;
    },
    /*获取素材类别*/
    getCategoryList() {
      let self = this;
      // 取到路由带过来的参数
      const params = self.$route.query.material_id;

      MaterialApi.toEditMaterial({material_id:params}, true)
        .then(res => {
          self.form = res.data.model;
          if(!self.form.image){
            self.form.image={};
          }
          if(res.data.model.product){
            self.product = {
              product_name:res.data.model.product.product_name,
              image:res.data.model.product.image[0].file_path,
            }
          }

          //发布人头像
          if(self.form.avatar){

            this.path = self.form.avatar.file_path;
            this.form.avatar = self.form.avatar.file_id;
            this.isImg = true;
          }
          //视频
          if(self.form.video){
            this.videopath = self.form.video.file_path;
            this.form.video = self.form.video.file_id;
            this.isVideo = true;
          }
          self.category = res.data.catgory;
          self.loading = false;

        })
        .catch(error => {

        });
    },

    /*编辑素材*/
    onSubmit() {
      let self = this;
      let form = self.form;

      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          MaterialApi.materialEdit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.$router.push('/plus/material/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消编辑，返回素材列表*/
    cancelFunc() {
      this.$router.push({
        path: '/plus/material/index'
      });
    },
     /*删除商品*/
    deleteFunc() {
      this.form.product_id = 0;
      this.product = {};
    },

    /*产品列表弹出层*/
    openProduct() {
      this.isproduct = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e) {
      this.isproduct = e.openDialog;
      console.log(e)
      if (e.type == 'success') {
        this.form.product_id = e.params.product_id;
        this.product = e.params;
      }
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/material/material/edit.vue